var HeadLogin = require("pc-login").loginBtnIndex
import LazyLoad from "@/components/lazyload"
window.LazyLoadIns = new LazyLoad();
import { getUserInfo } from '@/request/request'
import { performanceReport } from 'mpfe-utils'
import MeComment from './vuecomps/comment/MeComment.vue'
// 文章等级样式处理
import SgradeStyle from "@/config/article_abroad_sgrade"

// 设置Jquery和underScore依赖，解决delivery.js报错和评论组件报错问题
window.$ = window.Jquery = require('jquery')
window._ = require('underscore')
import Vue from "vue";
import { bindAriaEvent } from "./utils/bindAria";
import Share from '@/vuecomps/shareAbroad.vue'
import articleSGrade from '@/components/articleSGrade'
import { renderMiddleInsertVideo, renderRightBtns } from '@/pages/article_main/js/handleDom'
import Report from '@/components/report'
import {
    renderHeadVideo,
    renderSpecialBenefits,
} from '@/pages/article_main/js/handleDom'

export default function (opts) {
    opts.sGrade = articleSGrade(opts) ? articleSGrade(opts) : opts.sGrade
    window.pcArticleInfo = opts

    //登录条
    new HeadLogin({
        el: '#head-login',
        mark: 'article',
        type: 'other',
    })
    // 分享
    if (document.querySelector('#abroad-share-box')) {
        new Vue({
            el: '#abroad-share-box',
            components: {
                Share,
            },
        })
    }
    renderRightBtns()
    SgradeStyle(opts)
    renderHeadVideo(opts)
    renderMiddleInsertVideo()
    renderSpecialBenefits(opts) // 权益逻辑处理

    // 依赖登录信息的区块渲染
    getUserInfo()
        .then((res) => {
            if (res?.code == 1 && res?.data) {
                window.userInfo = res?.data
            }
        })
        .catch((error) => {
            console.log('获取用户信息失败', error)
        })
        .finally(() => {
            // 正文插入功能卡&推荐卡
            const mpPluginList = document.querySelectorAll(
                '#mp-editor mp-plugin'
            )
            if (mpPluginList?.length) {
                import(
                    /* webpackChunkName: "article-insert" */ './vuecomps/article-insert/index.js'
                )
                    .then((res) => {
                        res?.renderArticleInsert()
                    })
                    .catch((err) => {
                        console.log(err, '功能卡失败')
                    })
            }
        })
    renderComment()
    jumpToComment()
    // 展开更多功能
    const showMoreDom = document.querySelector('#showMore')
    if (showMoreDom) {
        showMoreDom.addEventListener('click', function (e) {
            e?.preventDefault()
            const hideEl = document.querySelector('.hidden-content')
            if (hideEl) hideEl?.classList?.remove('control-hide')
            const lookallBox = document.querySelector('.lookall-box')
            lookallBox?.classList?.add('control-hide')
            window?.sohuSpm?.sendAction({
                acode: 8434,
            })
        })
    }
    window.onload = () => {
        // 8256事件码上报
        performanceReport()
        // 绑定无障碍，关怀版点击
        bindAriaEvent()
        // 旧上报体系
        Report(opts)
    }
}

// 评论跳转(js控制，css不准)
const jumpToComment = ()=>{
    // url携带#comment_area跳转
    if(window.location.hash == '#comment_area') {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual'; // 禁止自动恢复滚动位置
        }
        setTimeout(()=>{
            window.scrollTo(0, document.getElementById("meComment")?.offsetTop);
        },1500)
    }
}

// 加载"评论"
const renderComment = ()=>{
    if(!document.querySelector('#meComment')) return
    new Vue({
        el: "#meComment",
        components: {
            MeComment
        },
    })
    if(!document.querySelector('#commentList')) return
    import(/* webpackChunkName: "article_comment_list" */'./vuecomps/comment/CommentList.vue')
    .then((res)=>{
        if(res && res.default) {
            const comp = res.default
            new Vue({
                el: "#commentList",
                components: {
                    CommentList: comp
                },
            })
        }
    }).catch((e)=>{
        console.log('渲染失败，评论',e)
    })
}